import { generateLocale } from './generate.js';

export default generateLocale([
  'Tên',
  'Tên không được nhỏ hơn 3 ký tự.',
  'E-Mail',
  'Vui lòng xác nhập địa chỉ email của bạn.',
  'Website',
  'Tùy chọn',
  'Hãy bình luận có văn hoá!',
  'Chưa có bình luận',
  'Gửi',
  'Thích',
  'Bỏ thích',
  'Trả lời',
  'Hủy bỏ',
  'bình luận',
  'Làm mới',
  'Tải thêm...',
  'Xem trước',
  'Emoji',
  'Tải lên hình ảnh',
  'giây trước',
  'phút trước',
  'giờ trước',
  'ngày trước',
  'Vừa xong',
  'Đang tải lên',
  'Đăng nhập',
  'đăng xuất',
  'Quản trị viên',
  'Dính',
  'từ',
  'Bình luận phải có độ dài giữa $0 và $1 từ!\n Số từ hiện tại: $2',
  'Vô danh',
  'Người lùn',
  'Người tí hon',
  'Thần rừng',
  'Pháp sư',
  'Tiên tộc',
  'Maiar',
  'Ảnh GIF',
  'Tìm kiếm ảnh GIF',
  'thông tin cá nhân',
  'Đã được phê duyệt',
  'Đang chờ đợi',
  'Thư rác',
  'Không dính',
  'lâu đời nhất',
  'muộn nhất',
  'nóng nhất',
  'What do you think?',
]);
